import {Grid} from "@material-ui/core";
import CallProviderBtn from "./CallProviderBtn";
import TruckPlate from "./TruckPlate";
import MoreProvidersDetailBtn from "./MoreProvidersDetailBtn";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    leftBox: {
        '& > *': {
            margin: ".2rem 0",
        },
    }
}));

const DriverInfo = props => {

    const classes = useStyles();

    return <Grid item>
        <Grid container direction={"column"} className={classes.leftBox}>
            <CallProviderBtn driver={props.driver}/>
            <TruckPlate driver={props.driver}/>
        </Grid>
    </Grid>
}
export default DriverInfo